// 稼働ボード表示用の純関数。依存ゼロ（scripts/test-agent-board.mjs で単体コンパイルする）。
// Rust 側の正: src-tauri/src/db/schema.sql agent_jobs.status / service/agent_jobs.rs

export type AgentJobStatus = "queued" | "running" | "done" | "needs_decision" | "failed";

export type StatusTone = "neutral" | "active" | "good" | "watch" | "danger";

export interface AgentJobTitleLike {
  missionTitle: string;
  prompt: string;
}

export interface AgentJobTimeLike {
  startedAt: string | null;
  finishedAt: string | null;
}

export function statusTone(status: AgentJobStatus): StatusTone {
  switch (status) {
    case "running":
      return "active";
    case "done":
      return "good";
    case "needs_decision":
      return "watch";
    case "failed":
      return "danger";
    default:
      return "neutral";
  }
}

export function statusLabel(status: AgentJobStatus): string {
  switch (status) {
    case "queued":
      return "待機中";
    case "running":
      return "実行中";
    case "done":
      return "完了";
    case "needs_decision":
      return "要判断";
    case "failed":
      return "失敗";
    default:
      return status;
  }
}

export function jobDisplayTitle(job: AgentJobTitleLike): string {
  const title = job.missionTitle.trim();
  if (title) return title;
  const head = (job.prompt.trim().split("\n")[0] ?? "").trim();
  if (!head) return "(無題ジョブ)";
  return head.length > 40 ? `${head.slice(0, 40)}…` : head;
}

export function formatDuration(ms: number): string {
  if (ms < 0) return "0s";
  const totalSec = Math.floor(ms / 1000);
  if (totalSec < 60) return `${totalSec}s`;
  return `${Math.floor(totalSec / 60)}m ${totalSec % 60}s`;
}

/** 実行中は nowMs 基準、終了済みは finishedAt 基準、未開始は "—" */
export function elapsedLabel(job: AgentJobTimeLike, nowMs: number): string {
  if (!job.startedAt) return "—";
  const start = Date.parse(job.startedAt);
  const end = job.finishedAt ? Date.parse(job.finishedAt) : nowMs;
  return formatDuration(end - start);
}

/** running/queued が残っているか（ボードの1秒tickの起動条件） */
export function hasActiveJobs(jobs: Array<{ status: AgentJobStatus }>): boolean {
  return jobs.some((job) => job.status === "running" || job.status === "queued");
}
